import { useState } from 'react';
import Text from './Text';
import { fontSizes } from '../constants/constants';
import ViewItems from './ViewItems';
import { MenuItem, Select } from '@mui/material';
import dynamicfunction from '../utils/dynamicfunction';
import { ReactSVG } from 'react-svg';
import ViewReverse from './ViewReverse';
import icons from '../constants/icons';
import { getContentKeyAccToLang } from '../utils/utils';
import { useSelector } from 'react-redux';
import CustomInput from './CustomInput';

const CustomDropdown = ({
  label,
  labelColor,
  options,
  selectedValue,
  onSelect,
  className,
  children,
  getContentKey,
  width = 'w-full',
  isBorder = true,
  valueKey,
  isError,
  isRequired,
  isSymbol,
  isDisabled,
  placeholder,
  isSearch = false,
  weight
}) => {
  const { isArabic } = dynamicfunction();
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  const { dashboardContent } = useSelector((state) => state.content);

  const handleSelect = (item) => {
    onSelect(item);
    setSearch("");
    setIsOpen(false);
  };

  const getPlaceholderKey = (key, isColon = false) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic, isColon);
  };

  const filteredOptions = options?.filter((item) =>
    (getContentKey
      ? getContentKey(item?.key)
      : isSymbol
      ? `${item?.name} - ${item?.symbol ?? item?.code}`
      : item?.[valueKey] ?? item?.label ?? item?.name
    )
      ?.toLowerCase()
      ?.includes(search?.toLowerCase())
  );

  return (
    <ViewItems className={`${width} relative ${className} ${isDisabled && 'opacity-50'}`}>
      {label && (
        <Text
          text={label}
          size={fontSizes.h14}
          color={isError ? 'text-red-500' : labelColor}
          className={'mb-[4px]'}
          isRequired={isRequired}
        />
      )}

      {children ? (
        <div onClick={() => !isDisabled && setIsOpen(!isOpen)}>{children}</div>
      ) : (
        <Select
          open={isOpen}
          onClose={() => (isSearch ? null : setIsOpen(false))}
          value={selectedValue ?? ''}
          inputProps={{ 'aria-label': 'Without label' }}
          displayEmpty
          className={`w-full !rounded-md pe-2 ${isBorder && `border ${isError ? 'border-red-500' : 'border-grey'}`}`}
          onKeyDownCapture={(e) => {
            e?.stopPropagation();
          }}
          disabled={isDisabled}
          renderValue={(value) => {
            return (
              <ViewReverse
                className={'w-full justify-between'}
                onClick={() => {
                  !isDisabled && setIsOpen(true);
                }}
              >
                <Text
                  text={
                    valueKey
                      ? value?.[valueKey] || getPlaceholderKey('select')
                      : isSymbol && value
                      ? value
                      : value?.label || value?.name || placeholder || getPlaceholderKey('select')
                  }
                  size={fontSizes.h14}
          weight={weight}

                />

                <ViewReverse className={'items-center gap-1 -me-4'}>
                  <ReactSVG src={icons.downArrow} />
                </ViewReverse>
              </ViewReverse>
            );
          }}
          sx={{
            '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
            },
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
            },
            '.MuiSelect-select': {
              padding: '10px',
            },
            '.MuiSelect-outlined': {
              padding: '10px',
            },
            '.MuiInputBase-input': {
              padding: '10px',
            },
            '.MuiOutlinedInput-input': {
              padding: '10px',
            },
            height: '40px',
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 250,
                maxWidth: 0,
                mt: 1,
                borderRadius: '8px',
              },
            },
            MenuListProps: {
              sx: {
                py: 0,
              },
            },
          }}
          IconComponent={() => null}
        >
          {isSearch && (
            <MenuItem
              key={'search'}
              disableTouchRipple
              disableGutters
              disableRipple
              sx={{
                justifyContent: isArabic ? 'flex-end' : 'flex-start',
                padding: 0,
                transition: 'all 0.3s ease',
              }}
            >
              <CustomInput
                value={search}
                onChange={(e) => setSearch(e?.target?.value)}
                border={'border-b'}
                placeholder={getPlaceholderKey('search')}
                isRounded={false}
              />
            </MenuItem>
          )}
          {(isSearch ? filteredOptions : options)?.map((item, index) => (
            <MenuItem
              key={index}
              value={item?.key || item?.id}
              onClick={() => handleSelect(item)}
              sx={{
                justifyContent: isArabic ? 'flex-end' : 'flex-start',
                padding: 0,
                transition: 'all 0.3s ease',
              }}
            >
              <Text
                size={fontSizes.h14}
                text={
                  getContentKey
                    ? getContentKey(item?.key)
                    : isSymbol
                    ? `${item?.name} - ${item?.symbol ?? item?.code}`
                    : item?.[valueKey] || item?.label || item?.name
                }
                className={"truncate w-full border-b border-b-grey py-3 mx-4"}
              />
            </MenuItem>
          ))}
        </Select>
      )}
    </ViewItems>
  );
};

export default CustomDropdown;
